export const STI_ROOT_PATH = '/st';
export const STI_PICKUP_ROOT_PATH = `${STI_ROOT_PATH}/walk-up`;
